import React, { forwardRef } from "react";
import { Box, Container, Typography, Grid, Link } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

const Footer = forwardRef((props, ref) => (
  <Box
    ref={ref}
    sx={{
      background: "#101c2c",
      color: "#fff",
      py: { xs: 3, sm: 5, md: 8 },
      fontFamily: "Poppins, Arial, sans-serif",
      borderTop: "4px solid #61dafb",
      boxShadow: "0 -8px 32px 0 #101c2c10",
      position: "relative",
      overflow: "hidden",
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 3, sm: 4, md: 26 }}>
        {/* Logo & Name */}
        <Grid item xs={12} md={4}>
          <Box sx={{ 
            mb: 2, 
            textAlign: { xs: 'center', md: 'left' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' }
          }}>
            <img
              src="/logo192.png"
              alt="logo"
              style={{
                height: { xs: 36, sm: 40, md: 48 },
                marginBottom: 12,
                borderRadius: 10,
                boxShadow: "0 2px 8px #61dafb33",
              }}
            />
            <Typography
              variant="h6"
              sx={{ 
                fontWeight: 900, 
                color: "#fff", 
                letterSpacing: 1,
                fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Gundeti Foundation
            </Typography>
          </Box>
        </Grid>

        {/* Resources Links */}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ 
            textAlign: { xs: 'center', sm: 'left', md: 'left' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', sm: 'flex-start', md: 'flex-start' }
          }}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 800, 
                mb: { xs: 1.5, md: 2 },
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}
            >
              Resources Links
            </Typography>
            <Box sx={{ 
              display: "flex", 
              flexDirection: "column", 
              gap: { xs: 0.5, md: 1 },
              alignItems: { xs: 'center', sm: 'flex-start', md: 'flex-start' }
            }}>
              <Link href="#" underline="hover" color="inherit" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' } }}>
                About Us
              </Link>
              <Link href="#" underline="hover" color="inherit" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' } }}>
                Blog
              </Link>
              <Link href="#" underline="hover" color="inherit" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' } }}>
                Terms of Service
              </Link>
              <Link href="#" underline="hover" color="inherit" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' } }}>
                Privacy Policy
              </Link>
            </Box>
          </Box>
        </Grid>

        {/* Contact Us */}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ 
            textAlign: { xs: 'center', sm: 'left', md: 'left' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', sm: 'flex-start', md: 'flex-start' }
          }}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 800, 
                mb: { xs: 1.5, md: 2 },
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ 
              display: "flex", 
              alignItems: "center", 
              gap: 1,
              justifyContent: { xs: 'center', sm: 'flex-start', md: 'flex-start' }
            }}>
              <EmailIcon sx={{ color: "#61dafb", fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' } }} />
              <Link
                href="mailto:lalitagundeti@gmail.com"
                color="inherit"
                underline="hover"
                sx={{ 
                  fontWeight: 600,
                  fontSize: { xs: '0.75rem', sm: '0.85rem', md: '1rem' },
                  wordBreak: 'break-word'
                }}
              >
                lalitagundeti@gmail.com
              </Link>
            </Box>
            <Typography
              variant="body2"
              sx={{ 
                mt: 1, 
                color: "#fff", 
                opacity: 0.7, 
                fontWeight: 500,
                fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.875rem' },
                textAlign: { xs: 'center', sm: 'left', md: 'left' }
              }}
            >
              4648 Rocky Road Philadelphia PA, 1920
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Footer Bottom */}
      <Box
        sx={{
          borderTop: "1.5px solid #61dafb",
          mt: { xs: 3, sm: 4, md: 6 },
          pt: 3,
          textAlign: "center",
          opacity: 0.85,
        }}
      >
        <Typography
          variant="body2"
          sx={{ 
            color: "#fff", 
            opacity: 0.7, 
            fontWeight: 500,
            fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.875rem' }
          }}
        >
          &copy; {new Date().getFullYear()} Gundeti Foundation. All rights
          reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
));

export default Footer;
